import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import Home from '../pages/Home';
import About from '../pages/About';
import Properties from '../pages/Properties';
import PropertyDetail from '../pages/PropertyDetail';
import Services from '../pages/Services';
import Contact from '../pages/Contact';
import PaymentSuccess from '../pages/PaymentSuccess';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import Error from '../pages/Error';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'properties',
        element: <Properties />,
      },
      {
        path: 'property/:id',
        element: <PropertyDetail />,
      },
      {
        path: 'services',
        element: <Services />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
      {
        path: 'payment-success',
        element: <PaymentSuccess />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
      },
      {
        path: '*',
        element: <Error />,
      },
    ],
  },
]);

export default router;
